export function setApiValidationErrorMessages(data, validator) {
  const errorData = data || null;
  if (errorData && 'errors' in errorData && Array.isArray(errorData.errors)) {
    const errors = errorData.errors;
    errors.forEach((e: any) => {
      validator.addMessage(e.code);
    });
  }
}

export function getStrippedValue(value) {
  return value ? value.replaceAll(/<[^>]*>/giu, '').replace(/\r\n|\r|\n/g, '') : value;
}
